
export default {
    computed: {
        loaderStatus(){
            return this.$store.state.LoaderStore.loader;
        }
    }
}
